import { fetchMainApi } from '@/api';

export const getCurrentUser = async () => {
  const response = await fetchMainApi('GET', '/users/me');
  return response.data || response;
};

export const getUsers = async (role, carrierStatus, page, limit) => {
  const params = new URLSearchParams();
  if (role) params.append('role', role);
  if (carrierStatus) params.append('carrierStatus', carrierStatus);
  if (page) params.append('page', page.toString());
  if (limit) params.append('limit', limit.toString());

  const queryString = params.toString();
  const url = queryString ? `/users?${queryString}` : '/users';

  return await fetchMainApi('GET', url);
};

export const uploadAvatar = async (userId, file) => {
  return await fetchMainApi('POST', `/users/${userId}/photo`, { body: file }, 'multipart/form-data');
};

export const removeAvatar = async (userId) => {
  return await fetchMainApi('DELETE', `/users/${userId}/photo`);
};

export const createUser = async (dto) => {
  return await fetchMainApi('POST', '/users', { body: JSON.stringify(dto) });
};

export const editUser = async (id, dto) => {
  return await fetchMainApi('PATCH', `/users/${id}`, { body: JSON.stringify(dto) });
};

export const updateCarrierStatusByAdmin = async (id, status) => {
  return await fetchMainApi('PATCH', `/users/edit/status/${id}`, { body: JSON.stringify({ status }) });
};

export const deleteUser = async (id) => {
  return await fetchMainApi('DELETE', `/users/${id}`);
};

export const changePassword = async (userId, currentPassword, newPassword) => {
  return await fetchMainApi('PATCH', `/users/${userId}`, {
    body: JSON.stringify({
      old_password: currentPassword,
      password: newPassword,
      password_confirmation: newPassword,
    })
  });
};

export const generateUserCredentials = async (token) => {
  const params = new URLSearchParams({ token });
  return await fetchMainApi('GET', `/users/generate/credentials/${token}?${params.toString()}`);
};

export const updateUser = async (data) => {
  return await fetchMainApi('PATCH', '/users', { body: JSON.stringify(data) });
};
